<template>
	<div class="steps">
		<Component
			:is="stepComponent"
			class="step"

			@show-ar-pop-up="$emit('show-ar-pop-up')"
		>

		</Component>
		<AddToCartBtn
			class="add-to-cart-btn"
			@click="$emit('show-demo-notify')"
		/>
	</div>
</template>

<script>
import DesignChanger from '@/components/Customizer/steps/DesignChanger';
import AddToCartBtn from '@/components/Customizer/AddToCartBtn';
import { computed } from 'vue';
import useCustomizer from '@/composables/Customizer';

const steps = Object.freeze({
	'design': DesignChanger,
});



export default {
	name: 'WizardSteps',
	components: {
		AddToCartBtn,
	},
	setup() {
		const {
			currentStep,
		} = useCustomizer();

		const stepComponent = computed(() => {
			const key = currentStep.value.type;

			return steps[key];
		});

		return {
			stepComponent,
		};

	},
};
</script>

<style lang="sass" scoped>
.step
	margin-bottom: 24px

.add-to-cart-btn
	@media (max-width: 650px)
		display: none
</style>
